import { render, staticRenderFns } from "./ListagemHistoricoVigencia.vue?vue&type=template&id=5e9e9276&scoped=true"
import script from "./ListagemHistoricoVigencia.vue?vue&type=script&lang=js"
export * from "./ListagemHistoricoVigencia.vue?vue&type=script&lang=js"
import style0 from "./ListagemHistoricoVigencia.vue?vue&type=style&index=0&id=5e9e9276&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e9276",
  null
  
)

export default component.exports